import React from 'react';
import {IonIcon} from '@ionic/react';
import {alertCircleSharp} from 'ionicons/icons';

import Panel from "../ui/Panel";
import RankedBars, {RankedBarRow} from "../ui/RankedBars";
import "./CardParts.css";

interface IncidentImpactCardProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  newdata: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  content: any;
}

/**
 * What incidents cost drivers, measured from probe speeds around each event
 * rather than from how long it lingers in a feed.
 */
const IncidentImpactCard: React.FC<IncidentImpactCardProps> = (props: IncidentImpactCardProps) => {
  const byType = props.newdata.incidentTypeDelay ?? [];
  if (byType.length === 0) {
    return null;
  }

  const worst = Math.max(...byType.map((t: {delay: number}) => t.delay), 1);
  const rows: RankedBarRow[] = byType.map((t: {name: string; count: number; delay: number}) => ({
    name: t.name,
    display: `${Math.round(t.delay)}s over ${t.count}`,
    percent: Math.round((t.delay / worst) * 100),
  }));

  return (
    <Panel
      title="Incident impact"
      subtitle={`${props.newdata.incidentsMeasured?.value ?? 0} incidents measured, past day`}
      accent="var(--domain-clearance)"
      icon={<IonIcon icon={alertCircleSharp} />}
      footer={`Updated ${props.content.updated}`}
    >
      <dl className="stat-pair">
        <div className="stat-pair__item">
          <dt>Median duration</dt>
          <dd>{props.newdata.incidentDuration?.value ?? '-'} min</dd>
        </div>
        <div className="stat-pair__item">
          <dt>Avg queue</dt>
          <dd>{props.newdata.queueLength?.value ?? '-'} mi</dd>
        </div>
        <div className="stat-pair__item">
          <dt>Longest queue</dt>
          <dd>{props.newdata.queueLengthMax?.value ?? '-'} mi</dd>
        </div>
      </dl>
      <h3 className="card-subhead">Delay per vehicle, by type</h3>
      <div className="dashboard__scroll">
        <RankedBars rows={rows} accent="var(--domain-clearance)" />
      </div>
    </Panel>
  );
};

export default IncidentImpactCard;
